import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function Sitemap() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Sitemap</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Sitemap</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Sitemap</h1>
                            <ul className="sitemap">
                                <li><NavLink to="/">Home</NavLink></li>
                                <li>
                                    About Us
                                    <ul>
                                        <li><NavLink to="/AboutUs">About Us</NavLink></li>
                                        <li><NavLink to="/OurMotto">Our Motto</NavLink></li>
                                        <li><NavLink to="/MissionVision">Mission & Vision</NavLink></li>
                                        <li><NavLink to="/PrincipalsMessage">Principal's Message</NavLink></li>
                                        <li><NavLink to="/SchoolPhilosophy">School Philosophy</NavLink></li>
                                        <li><NavLink to="/StaffDetails">Staff Details</NavLink></li>
                                    </ul>
                                </li>
                                <li><NavLink to="/Activities">Activities</NavLink></li>
                      
                                <li>
                                    Admission
                                    <ul>
                                        <li><NavLink to="/AdmissionDetails">Admission Details</NavLink></li>
                                        <li><NavLink to="/Booklist">Booklist</NavLink></li>
                                        <li><NavLink to="/FeeStructure">Fee Structure</NavLink></li>
                                    </ul>
                                </li>
                                <li><NavLink to="/Gallery">Gallery</NavLink></li>
                                <li><NavLink to="/Contact">Contact</NavLink></li>
                                <li>
                                    Useful Links
                                    <ul>
                                        <li><NavLink to="/TCIssued">TC Issued</NavLink></li>
                                        <li><NavLink to="/SchoolErp">School ERP</NavLink></li>
                                        <li><NavLink to="/PortalHelp">Portal (Help)?</NavLink></li>
                                        <li><NavLink to="/Sitemap">Sitemap</NavLink></li>
                                        <li><NavLink to="/Gallery">Gallery</NavLink></li>
                                    </ul>
                                </li>


                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default Sitemap